export default __webpack_public_path__ + "static/media/bikingIcon.caad5002.svg";